// extracted by mini-css-extract-plugin
module.exports = {"footer_bg":"footer_footer_bg__xYVPu","mains":"footer_mains__1uiKw","footer_text":"footer_footer_text__eU4g2"};